import { BatteryChargingIcon, CircleDollarSignIcon, MagnetIcon, PickaxeIcon, SettingsIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Industry Fundamentals & Strategic Resources',
    summary: 'Critical minerals definition, lithium properties, resource types, major minerals, applications, global structure, strategic challenges.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Lithium Geology, Exploration & Resource Evaluation',
    summary: 'Deposit types, geological formation, exploration methods, drilling, sampling, resource evaluation, mineral classification.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'Lithium Mining, Brine Production & Advanced Extraction Technologies',
    summary: 'Hard-rock mining, mineral processing, brine production, DLE technologies, extraction performance, technology comparison.',
    icon: MagnetIcon,
  },
  {
    number: '4',
    title: 'Lithium & Critical Minerals Processing and Refining Technologies',
    summary: 'Hydrometallurgy, chemical processing, lithium carbonate/hydroxide, battery-grade refining, other critical minerals.',
    icon: PickaxeIcon,
  },
  {
    number: '5',
    title: 'Battery Materials, Energy Storage Technologies & Industrial Applications',
    summary: 'Lithium-ion batteries, cathode/anode materials, battery manufacturing, performance, applications, emerging technologies, recycling.',
    icon: BatteryChargingIcon,
  },
  {
    number: '6',
    title: 'Critical Minerals Project Economics, Sustainability & Global Supply Chains',
    summary: 'Project development, CAPEX/OPEX, financial modeling, NPV/IRR, environmental sustainability, supply chain analysis.',
    icon: CircleDollarSignIcon,
  },
];
